module.exports = __webpack_public_path__ + "img/autruchesamere.fee8233b.png";